$(document).on("click", ".tablinks", function () {
  var $this = $(this);
  var cityName = $this.data("city");
  var $section = $this.closest(".tab-section");
  // Hide all tab content and remove active class in the current section
  $section.find(".tabcontent").hide().removeClass("active");
  $section.find(".tablinks").removeClass("active");
  // Show the current tab content and set active class
  $section.find("#" + cityName).show().addClass("active");
  $this.addClass("active");
});
$(document).on("click", ".custom_filters", function () {
  // Run only if screen width is 768px or less (you can change this breakpoint)
  if ($(window).width() <= 989) {
    const $filters = $(".collection__sidebar-menu");
    const $title = $(this).find("h3");
    $filters.toggle();
    if ($filters.is(":visible")) {
      $title.text("Hide Filter");
    } else {
      $title.text("Filter");
    }
  }
});
$(document).ready(function(){
    $(".custom__inbox-chat").click(function(){
        var checkExist = setInterval(function() {
            var chatApp = document.querySelector("#ShopifyChat"); 
            if (chatApp && chatApp.shadowRoot) { 
                var chatbotButton = chatApp.shadowRoot.querySelector('button[data-spec="toggle-button"]'); 
                if (chatbotButton) {
                    clearInterval(checkExist); 
                    chatbotButton.click(); 
                    console.log("Chatbot button clicked from shadow DOM!");
                }
            }
        }, 500); 
    });
});




function querySelectorDeep(selector, root = document) {

  const el = root.querySelector(selector);
  if (el) return el;


  const nodes = root.querySelectorAll('*');
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];
    if (node.shadowRoot) {
      const found = querySelectorDeep(selector, node.shadowRoot);
      if (found) return found;
    }
  }
  return null;
}

document.querySelector('.custom__inbox-chat')?.addEventListener('click', function (e) {

  const tidioHost = document.querySelector('#tidio-chat-root');
  let btn = null;

  if (tidioHost) {

    if (tidioHost.shadowRoot) {
      btn = querySelectorDeep('button', tidioHost.shadowRoot);
    } else {

      btn = querySelectorDeep('#tidio-chat-root button') || querySelectorDeep('button');
    }
  } else {

    btn = querySelectorDeep('#tidio-chat-root button') || querySelectorDeep('button.tidio-chat-button') || null;
  }

  if (btn) {
    btn.click();
    return;
  }


  if (window.tidioChatApi && typeof window.tidioChatApi.open === 'function') {
    window.tidioChatApi.open();
    return;
  }


  const host = document.querySelector('#tidio-chat-root');
  if (host) {
    host.dispatchEvent(new CustomEvent('openTidioChat', { bubbles: true }));
    return;
  }

  console.warn('Tidio button not found and no global API available — cannot open chat programmatically.');
});